import { configureStore } from "@reduxjs/toolkit";
import userBalanceReducer from "./stores/balance/userBalance";
import userAuthReducer from "./stores/auth/userAuth";
import loginBonusReducer from "./stores/bonus/loginBonus";
import uiStatesReducer from "./stores/ui/uiStates";

export default configureStore({
  reducer: {
    userBalance: userBalanceReducer,
    userAuth: userAuthReducer,
    loginBonus: loginBonusReducer,
    uiStates: uiStatesReducer,
  },
});
